import React from 'react';
import { SymbolicTeamFormation } from 'modules/championship/domain/enums/symbolic-team-formation';
import { SymbolicTeamFormPlayer } from 'modules/championship/domain/interfaces/symbolic-team-form-player';
import { PlayerCard } from './player-card';
import { FootballField } from './team-formation.styles';

interface TeamFormationProps {
  formation: SymbolicTeamFormation;
  players: SymbolicTeamFormPlayer[];
  selectedRank: number | null;
  onRankSelect?: (rank: number) => void;
}

export const TeamFormation = ({ formation, players, selectedRank, onRankSelect }: TeamFormationProps) => {
  return (
    <FootballField className={`formation-${formation}`}>
      {players.map((player) => (
        <PlayerCard
          className={`player-card player-${player.rank}`}
          key={player.rank}
          formation={formation}
          player={player}
          isRankActive={selectedRank === player.rank}
          onSelect={onRankSelect}
        />
      ))}
    </FootballField>
  );
};
